import React, { useEffect, useRef } from "react";
import s from "./style.module.css";

const VideoEmbed = ({ id }) => {
  const idForDiv = useRef(Math.random().toString(20).substr(2, 6));

  useEffect(() => {
    if (!window.s7viewers) {
      return;
    }

    /* eslint-disable */
    var s7videoviewer = new window.s7viewers.VideoViewer({
      containerId: idForDiv.current,
      params: {
        serverurl: "https://worldbank.scene7.com/is/image/",
        contenturl: "https://worldbank.scene7.com/is/content/",
        config: "worldbankprod/WBG-SocialShare-Player",
        posterimage: id,
        videoserverurl: "https://worldbank.scene7.com/is/content",
        asset: id,
      },
    });
    s7videoviewer.init();
  }, []);

  return (
    <div className={s.container}>
      <div className={s.inner}>
        <div id={idForDiv.current}></div>
      </div>
    </div>
  );
};

export default VideoEmbed;
